import React, { useEffect, useState } from 'react';

interface ServiceLogViewProps{
	logId?: number,
}

var ServiceLogView = (props: ServiceLogViewProps)=>{
	useEffect(()=>{
		
	}, []);
	
	return <div>
		
	</div>
}

export default ServiceLogView;